<template>
	<div>
		<div class="row">
			<div class="col-md-12 p-0">
				<div class="row">
					<div class="col-md-6">
						<BarCard title="SALES PER DAY (M)" :data="weekly.spd" :width="500" :height="280" url="/bright/report?tab=1"/>
					</div>
					<div class="col-md-6">
						<BarCard title="SALES EX TAX (M)" :data="weekly.sales" :width="500" :height="280" url="/bright/report?tab=0"/>
					</div>
					<div class="col-md-6">
						<BarCard title="MARGIN (%)" :data="weekly.margin" :width="500" :height="280" url="/bright/report?tab=0"/>
					</div>
					<div class="col-md-6">
						<BarCard title="NO OF INVOICE" :data="weekly.inv" :width="500" :height="280" url="/bright/report?tab=1"/>
					</div>
					<div class="col-md-6">
						<BarCard title="AVERAGE BASKET (K)" :data="weekly.basket" :width="500" :height="280" url="/bright/report?tab=1"/>
					</div>
					<div class="col-md-6">
						<BarCard title="WASTE (M)" :data="weekly.waste" :width="500" :height="280" url="/bright/report?tab=2"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import BarCard from '@/views/pages/BarCard.vue'

export default{
	extends: Cafe,
	components:{
		BarCard,
    },
    mounted(){
		this.$emit('childrenRoute')
		this.loadWeekly();
    },
    methods:{
    },
}
</script>
<style>
.home.row1,.home.row2{ height: 300px;}
.text-merah{ color:#c7251c }
.text-biru{ color:#066fb1   }
.text-hijau{ color:#acc437  }
</style>